export const FETCH_SEARCH_RESULTS = "FETCH_SEARCH_RESULTS";
export const FETCH_DOWNLOAD_LINKS = "FETCH_DWONLOAD_LINKS";
export const LOAD_SEARCH_RESULTS = "LOAD_SEARCH_RESULTS";
export const SET_DEFAULT_SEARCH_VALUE = "SET_DEFAULT_SEARCH_VALUE";
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const FETCH_READING_LIST = "FETCH_READING_LIST";
export const CLEAR_READING_LIST = "CLEAR_READING_LIST";
export const FETCH_BOOK_DETAILS = "FETCH_BOOK_DETAILS";
export const LOAD_BOOK_DETAILS = "LOAD_BOOK_DETAILS";
